import { Box } from '@mui/material'
import { Link } from '@rentspree/component-2023.components.atoms.link'
import { Typography } from '@rentspree/component-2023.components.atoms.typography'

import env from 'env'

import styles from './footer-rights-reserved.module.scss'

const internalLink = (uri: string): string => `${env.BASE_URL}${uri}`

export const footerRightReservedLinks: FooterLink[] = [
  { displayText: 'Privacy policy', link: internalLink('/rentspree-privacy-policy') },
  { displayText: 'Terms of service', link: internalLink('/terms-of-service') },
  { displayText: 'Additional legal terms', link: internalLink('/additional-legal-terms') },
]
export const FooterRightsReserved: React.FC = () => (
  <Box className={styles.rightsReservedContainer}>
    <Typography variant="body">© 2025 RentSpree. All rights reserved</Typography>
    <Box className={styles.rightsReservedLinksContainer}>
      {footerRightReservedLinks.map(({ displayText, link }: FooterLink) => (
        <Link
          key={`rights-reserved-${displayText}`}
          variant="bodySmall"
          href={link}
          target="_blank"
          color="black"
        >
          {displayText}
        </Link>
      ))}
      <Link
        key="rights-reserved-cookie-settings"
        id="cookie-settings"
        variant="bodySmall"
        href="#cookie-settings"
        onClick={(e) => {
          e.preventDefault()
        }}
        color="black"
        className="ot-sdk-show-settings"
        target="_self"
      >
        Cookie settings
      </Link>
    </Box>
  </Box>
)
